import { useEffect } from "react";
import { useI18nStore } from "../store/i18n.store";
import { useAuthStore } from "../store/auth.store";

// Import translation files
import csTranslations from "../locales/cs.json";
import skTranslations from "../locales/sk.json";
import enTranslations from "../locales/en.json";

const translations = {
  cs: csTranslations,
  sk: skTranslations,
  en: enTranslations,
};

export const useTranslation = () => {
  const { t, currentLanguage, setLanguage, setTranslations } = useI18nStore();
  const getCurrentLanguage = useAuthStore((state) => state.getCurrentLanguage);

  useEffect(() => {
    // Load all translations
    setTranslations(translations);

    // Set language based on user's agenda_id
    const userLanguage = getCurrentLanguage();
    if (userLanguage !== currentLanguage) {
      setLanguage(userLanguage);
    }
  }, [getCurrentLanguage, currentLanguage, setLanguage, setTranslations]);

  return { t, currentLanguage };
};
